import { graphql, useStaticQuery } from 'gatsby';

import { parseStoryblokContent } from './parse-storyblok-content';

export function useFooter() {
  const { footer } = useStaticQuery(graphql`
    query {
      footer: storyblokEntry(field_component: { eq: "footer" }) {
        id
        name
        uuid
        field_component
        content
      }
    }
  `);

  return parseStoryblokContent(footer);
}
